import { get } from './client';
import { CpgFinderResponse } from '../../models/services/api/getCpgFinder';
import { log } from '@domgen/shared/utils/log';

export const getCpgData = async (modelNumber: string) => {
  try {
    const res = await get<CpgFinderResponse>(`/cpgfinder?modelNumber=${modelNumber}`);
    return res;
  } catch (err) {
    log.error({ message: 'CPG Finder error', data: err });
    throw err;
  }
};
